import { DEFAULT_TOOL_TIP_DELAY } from './Tooltip.types';
import type { TooltipProps } from './Tooltip.types';

/**
 * @deprecated
 * Note: Tooltip has been replaced by QTip - a singleton JS tooltip that behaves well even with overflow settings :)
 * See @QTip for more info!
 *
 * This component displays a Tooltip for the provided children. It is a CSS only tooltip that will not display
 * correctly if a parent element has an overflow CSS property assigned. Please use QTip to ensure your tooltips
 * display correctly.
 */
export const Tooltip = ({ position = 'bottom', children, text, delay = DEFAULT_TOOL_TIP_DELAY }: TooltipProps) => {
  const arrowBaseClasses = "tw:before:content-[''] tw:before:absolute tw:before:border-8";
  const centerArrowVertically = 'tw:before:top-1/2 tw:before:-translate-y-1/2';
  const centerArrowHorizontally = 'tw:before:left-1/2 tw:before:-translate-x-1/2';
  const arrowRight = `${arrowBaseClasses} ${centerArrowVertically} tw:before:right-full tw:before:border-y-transparent 
  tw:before:border-l-transparent tw:before:border-r-sq-black`;

  const arrowLeft = `${arrowBaseClasses} ${centerArrowVertically} tw:before:left-full tw:before:border-y-transparent
   tw:before:border-l-sq-black tw:before:border-r-transparent`;

  const arrowBottom = `${arrowBaseClasses} ${centerArrowHorizontally} tw:before:-top-4 tw:before:border-b-sq-black 
  tw:before:border-r-transparent tw:before:border-l-transparent tw:before:border-t-transparent`;
  const arrowTop = `${arrowBaseClasses} ${centerArrowHorizontally} tw:before:-bottom-4 tw:before:border-b-transparent 
  tw:before:border-t-sq-black tw:before:border-l-transparent tw:before:border-r-transparent`;

  const placements = {
    top: `tw:-top-2 tw:-translate-y-full tw:left-1/2 tw:-translate-x-1/2 ${arrowTop}`,
    left: `tw:-translate-x-full tw:-left-3 tw:-translate-y-1/2 tw:top-1/2 ${arrowLeft}`,
    right: `tw:translate-x-full tw:-right-3 tw:-translate-y-1/2 tw:top-1/2 ${arrowRight}`,
    bottom: `tw:-bottom-2 tw:translate-y-full tw:left-1/2 tw:-translate-x-1/2 ${arrowBottom}`,
  };

  return (
    <div className="tw:group tw:relative tw:inline-block">
      {children}
      <div
        // eslint-disable-next-line better-tailwindcss/no-unknown-classes
        className={`tw:z-50 tw:hidden tw:whitespace-nowrap tw:group-hover:inline-block tw:group-hover:delay-[${delay}ms]
        tw:absolute tw:rounded-sm tw:bg-sq-black tw:p-2 tw:text-xs tw:text-sq-white tw:opacity-0 tw:group-hover:opacity-100 ${placements[position]}`}>
        {text}
      </div>
    </div>
  );
};
